<template>
  <div>
  <h6>Inline Buttons</h6>
  <div v-for="(row, rowIndex) in inline_keyboard" :key="rowIndex">
    <div class="form-row">
      <div v-for="(btn,colIndex) in row" :key="colIndex" class="col" style="min-width:200px">
          <div class="input-group mb-3">
            <input  type="text" class="form-control" v-model.trim="btn.text" @keyup="updateActionCallbackbutton(btn)" placeholder="Button Text">
            <input  v-if="btn.type=='callback_data'" type="text" class="form-control" v-model.trim="btn.callback_data" @keyup="updateActionCallbackbutton(btn)" placeholder="Callback Data" maxlength="64">
            <input  v-if="btn.type=='url'" type="text" class="form-control" v-model="btn.url" @keyup="updateActionCallbackbutton(btn)" placeholder="URL" >
            <input  v-if="btn.type=='login_url'" type="text" class="form-control" v-model="btn.login_url.url" @keyup="updateActionCallbackbutton(btn)" placeholder="Login URL" >
            <div class="input-group-append">
              <button @click="removeButton(rowIndex, colIndex)" class="btn btn-outline-danger btn-sm">X</button>
            </div>
          </div>
      </div>
      <div>
          <div class="input-group mb-3">
            <div class="btn-group"  v-if="row.length < 4">
              <button @click="addButton(rowIndex)" class="btn btn-sm btn-outline-success">+</button>
              <button type="button" class="btn btn-outline-success dropdown-toggle dropdown-toggle-split" data-toggle="dropdown">
              </button>
              <div class="dropdown-menu">
                <div class="radio">
                  <label><input type="radio" name="optradio" value="callback_data" v-model="type"> Callback button</label>
                </div>
                <div class="radio">
                  <label><input type="radio" name="optradio" value="url" v-model="type"> URL button</label>
                </div>
                <div class="radio">
                  <label><input type="radio" name="optradio" value="login_url" v-model="type"> Login URL button</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  <div class="btn-group">
    <button @click="addButtonRow" type="button" class="btn btn-sm btn-outline-success">+</button>
    <button type="button" class="btn btn-outline-success dropdown-toggle dropdown-toggle-split" data-toggle="dropdown">
    </button>
    <div class="dropdown-menu">
      <div class="radio">
        <label><input type="radio" name="optradio" value="callback_data" v-model="type"> Callback button</label>
      </div>
      <div class="radio">
        <label><input type="radio" name="optradio" value="url" v-model="type"> URL button</label>
      </div>
      <div class="radio disabled">
        <label><input type="radio" name="optradio" value="login_url" v-model="type"> Login URL button</label>
      </div>
    </div>
  </div>
  </div>
</template>


<script>
export default {
  name: 'InlineKeyboard',
  props: {
    inline_keyboard: Array,
    actions: Object
  },
  data: function(){
    return {
      type: 'callback_data'
    }
  },
  methods:{
    addButton: function(row){
      let id = Date.now()
      id = id.toString()
      let button = {"text":null, "callback_data":null, "id":id};
      var type = this.type
      if(this.type == 'callback_data'){
        button = {"text":null, "callback_data":null, "id":id, "type":type};
        this.actions.callbacks.push({button:button, chat:null, prime:false});
      }
      else if(this.type == 'url')
        button = {"text":null, "url":null, "id":id, "type":type};
      else if(this.type == 'login_url')
        button = {"text":null, "login_url":{"url":null, "request_write_access":true}, "id":id, "type":type};
      this.inline_keyboard[row].push(button);
    },
    updateActionCallbackbutton:function(btn){
      this.actions.callbacks.forEach(function(value){
        if(value.button.id == btn.id){
          value.button.text = btn.text;
          value.button.callback_data = btn.callback_data;
        }
      })
    },
    removeButton: function(row,col){
      let btn = this.inline_keyboard[row][col];
      this.inline_keyboard[row].splice(col,1);

      if(this.inline_keyboard[row].length == 0)
        this.inline_keyboard.splice(row,1);

      this.actions.callbacks = this.actions.callbacks.filter(function (value) {
        return value.button.id != btn.id;
      });
    },
    addButtonRow: function(){
      let id = Date.now()
      id = id.toString()
      let button = {}
      var type = this.type
      if(this.type == 'callback_data'){
        button = {"text":null, "callback_data":null, "id":id, "type":type};
        this.actions.callbacks.push({button:button, chat:null, prime:false});
      }
      else if(this.type == 'url')
        button = {"text":null, "url":null, "id":id, "type":type};
      else if(this.type == 'login_url')
        button = {"text":null, "login_url":{"url":null, "request_write_access":true}, "id":id, "type":type};
      this.inline_keyboard.push([button]);
    },
  },

}
</script>
